module.exports = __webpack_public_path__ + "static/media/Guided Surgery_2.310d924d.png";